import { render, staticRenderFns } from "./verify_document.vue?vue&type=template&id=2f10b7be&scoped=true"
import script from "./verify_document.vue?vue&type=script&lang=js"
export * from "./verify_document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10b7be",
  null
  
)

export default component.exports